import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { closeFlash, setFlash, setAuthAction, startLoading, doneLoading, loginUser } from "./../../Redux/actions/index";
import { Trans } from "react-i18next";

const mapStateToProps = state => {
  return {
    auth: state.session.auth,
    user: state.session.user
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setAuth: user => dispatch(setAuthAction(user)),
    doneLoading: () => dispatch(doneLoading()),
    isLoading: p => dispatch(startLoading(p)),
    setFlash: f => dispatch(setFlash(f)),
    closeFlash: f => dispatch(closeFlash(f))
  };
}

class LoginBox extends Component {
  constructor(props) {
    super(props);

    this.props.doneLoading();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.passwordRef = React.createRef();

    this.state = {
      messageSpan: "",
      confirmation: false,
      form: {
        platform: "web",
        username: "",
        password: "",
        code: ""
      }
    };

    props.closeFlash();
  }

  handleInputChange(e) {
    let s = this.state;
    s.form[e.target.name] = e.target.value;
    this.setState({ ...s });
  }

  checkPassword(password) {
    //Regex to check if a string contains uppercase, lowercase special character & numeric value
    var pattern = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$");

    if (!password || password.length < 10) {
    this.setState({validUsername: false});
        return false;
      }

      if (pattern.test(password)) {
    this.setState({validUsername: true});
        return true;

      } else {
    this.setState({validUsername: false});
          return false;
      }
  }

  handleSubmit(e) {
    e.preventDefault();
    let that = this;

    if (!this.checkPassword(this.state.form.password)) {
      that.props.setFlash({
        active: true,
        message: "Enter a valid password",
        classes: "warning",
        style: {}
      });

      return;
    }

    /*if(this.state.form.password.length === 0)
			return this.passwordRef.current.focus();*/

    if (this.state.form.password.length < 4 || this.state.form.password.length < 4) {
      that.props.setFlash({
        active: true,
        message: "Enter valid username & password",
        classes: "warning",
        style: {}
      });

      return;
    }

    loginUser(this.state.form);
  }

  render() {
    //console.log("hello auth", this.props.user.role);

    //if the user is a CM manager then go to CM
    if (this.props.auth) {
      if(this.props.user.role === "problem_manager" || this.props.user.role === "cm_creator" || this.props.user.role === "service") {
        return <Redirect to={"/cm"} />;
      } else {
        return <Redirect to={"/flm"} />;
      }
    }

    return (
      <div>
        <div className={"container-header"}>
          <Trans i18nKey="label_signin" />
        </div>

        <span className={"mb-4"}>{this.state.messageSpan}</span>
        <div className="col-md-5 login-box">
          <form onSubmit={this.handleSubmit} name="loginForm">
            <input type="hidden" name="hidden" value="aze" />

            <div className={"c-form-row form-group"}>
              <label className="label-style">
                <Trans i18nKey="user_username" />{" "}
              </label>
              <input
                disabled={this.state.confirmation}
                tabIndex="1"
                className="input-style"
                type="text"
                name="username"
                onChange={this.handleInputChange}
                value={this.state.form.username}
              />
              <br />
            </div>

            <div className={"c-form-row form-group"}>
              <label className="label-style">
                <Trans i18nKey="user_password" />{" "}
              </label>
              <input
                disabled={this.state.confirmation}
                ref={this.passwordRef}
                tabIndex="2"
                className="input-style"
                type="password"
                name="password"
                onChange={this.handleInputChange}
                value={this.state.form.password}
              />
            </div>

            {this.state.confirmation ? (
              <div className={"c-form-row form-group"}>
                <label className="label-style">
                  <Trans i18nKey="confirmation_code" />{" "}
                </label>
                <input
                  tabIndex="3"
                  className="input-style"
                  type="text"
                  name="code"
                  onChange={this.handleInputChange}
                  value={this.state.form.code}
                />
              </div>
            ) : (
              ""
            )}

            <div className={"c-form-row form-group"}>
              <button className={"btn btn-block btn-primary"} type="submit">
                <Trans i18nKey="label_signin" />
              </button>
            </div>

            {/* <div className={"c-form-row mt-4"}>
						<a href="#"><span className={"btn btn-info float-left"}><Trans i18nKey="label_joinus" /></span></a>
						<span className={"float-right"}><a href="#"><Trans i18nKey="password_recovery" /></a></span>
					</div> */}

            <div className="clear" />
          </form>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginBox);
